import * as React from 'react';

import { ProductCarousel, ProductThumbnail } from 'modules/catalogue/components';
import { CarouselCatalogueBlocContainerProps } from '.';

export const CarouselCatalogueBlocContainer: React.FC<CarouselCatalogueBlocContainerProps> = ({
    products,
}: CarouselCatalogueBlocContainerProps) => {
    if (products.length > 0) {
        return (
            <ProductCarousel>
                {products.map((product, index) => {
                    // eslint-disable-next-line react/no-array-index-key
                    return <ProductThumbnail key={`${product.id}-${index}`} product={product} centerLabels />;
                })}
            </ProductCarousel>
        );
    }

    return <React.Fragment />;
};
